import { Controller } from "@hotwired/stimulus"

const csrfToken = () => document.querySelector('meta[name="csrf-token"]')?.content

// Global "Sync now" affordance in the TopBar (doc 13 #3) — POSTs the same
// sync_shopify_connection_path every per-page "Sync now" button does, which
// enqueues the one full Partners::SyncOrchestratorJob (transactions, customers,
// subscriptions all refresh together). Polls the connection status JSON until
// the run completes, then reloads so the server-rendered freshness chip
// (Rails time_ago_in_words) picks up the new timestamp — simpler than
// re-deriving that formatting in JS.
export default class extends Controller {
  static targets = ["button"]
  static values = {
    syncPath: String,
    statusPath: String,
    copyRequested: String,
    copySyncing: String,
    copyThrottled: String,
    copyError: String,
  }

  disconnect() {
    this.stopPolling()
  }

  async sync() {
    if (!this.hasButtonTarget || this.buttonTarget.disabled) return
    this.setLabel(this.copyRequestedValue, true)

    try {
      const res = await fetch(this.syncPathValue, {
        method: "POST",
        headers: { "X-CSRF-Token": csrfToken(), Accept: "application/json" },
      })
      if (res.status === 429) {
        this.setLabel(this.copyThrottledValue, false)
        return
      }
      if (!res.ok) throw new Error("sync failed")
      this.startPolling()
    } catch {
      this.setLabel(this.copyErrorValue, false)
    }
  }

  setLabel(text, disabled) {
    this.buttonTarget.textContent = text
    this.buttonTarget.disabled = disabled
  }

  startPolling() {
    this.setLabel(this.copySyncingValue, true)
    let attempts = 0
    const maxAttempts = 15
    this.pollId = setInterval(async () => {
      attempts += 1
      if (attempts > maxAttempts) return this.stopPolling()
      try {
        const res = await fetch(this.statusPathValue, { headers: { Accept: "application/json" } })
        if (!res.ok) return
        const body = await res.json()
        if (body.sync?.state !== "running") {
          this.stopPolling()
          window.location.reload()
        }
      } catch {
        // transient failure — keep polling rather than abandoning the wait
      }
    }, 2500)
  }

  stopPolling() {
    if (this.pollId) clearInterval(this.pollId)
    this.pollId = null
  }
}
